module.exports = __webpack_public_path__ + "static/media/company3.d8b9e39a.png";